import React from 'react';
import { Button } from '@ipc/ipc-components';
import { PropTypes } from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { primaryButton } from '../../styles/themes';

function AlertDialog({
  open, confirmTitle, dismissTitle, onConfirmation, onDismiss, title, children, isLargeModal = false,
}) {
  // const [open, setOpen] = useState(!!defaultOpen);

  const handleDismiss = () => {
    if (typeof onDismiss === 'function') {
      onDismiss();
    }
    // setOpen(false);
  };

  const handleConfirm = () => {
    if (typeof onConfirmation === 'function') {
      onConfirmation();
    }
    // setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleDismiss}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        data-testid="modal-dialog"
        maxWidth={isLargeModal ? 'md' : false}
        fullWidth={isLargeModal}
      >
        {isLargeModal ? (
          <DialogTitle style={{ color: '#073142', fontFamily: 'Open Sans Condensed', fontWeight: 'bold' }} id="alert-dialog-title">{title}</DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        )}
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions>
          {onDismiss && (
            <Button onClick={handleDismiss} data-testid="dismiss-modal">
              {dismissTitle || 'Cancel'}
            </Button>
          )}
          {onConfirmation && (
            <Button onClick={handleConfirm} theme={primaryButton} data-testid="confirm-modal">
              {confirmTitle || 'Ok'}
            </Button>
          )
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}

AlertDialog.propTypes = {
  open: PropTypes.bool,
  confirmTitle: PropTypes.string,
  dismissTitle: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  onConfirmation: PropTypes.func,
  onDismiss: PropTypes.func,
  isLargeModal: PropTypes.bool,
};


export default AlertDialog;
